import { render } from "./UpdateFormTicketsTestBootstrap.vue?vue&type=template&id=32b1991c"
const script = {}

import "./UpdateFormTicketsTestBootstrap.vue?vue&type=style&index=0&id=32b1991c&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__